/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UpdatingInputs */

const en_updating = /** @type {(inputs: UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating...`)
};

const de_updating = /** @type {(inputs: UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierung…`)
};

/**
* | output |
* | --- |
* | "Updating..." |
*
* @param {UpdatingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const updating = /** @type {((inputs?: UpdatingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UpdatingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_updating(inputs)
	return de_updating(inputs)
});